import React from "react";

import SingleCardSlider from "../single-card-slider";

import "./single-big-card-slider.m.css";

const SingleBigCardSlider = ({ collection, index }) => {
  return (
    <div styleName="big-card-slider">
      <SingleCardSlider collection={collection} index={index} />
    </div>
  );
};

export default SingleBigCardSlider;
